import { z } from 'zod';

import type { EndpointContractGroup } from '../schemaUtils';

export const resendStatus = z.enum(['email-sent', 'already-verified']);
export type ResendStatus = z.infer<typeof resendStatus>;

/**
 * Schema definition for all auth endpoints
 */
export const authApiSchemas = {
  register: {
    resend: {
      path: '/chats/:chatId/auth/register/resend',
      method: 'POST',
      schema: {
        params: z.object({
          chatId: z.string(),
        }),
        body: z.object({
          email: z.string().email(),
          utmParams: z.record(z.string()).optional(),
        }),
        response: {
          200: z.object({
            status: resendStatus,
          }),
        },
      },
    },
  },
} satisfies EndpointContractGroup;
